import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import QuizIcon from '@mui/icons-material/Quiz';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import BusinessIcon from '@mui/icons-material/Business';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import BuildIcon from '@mui/icons-material/Build';
import axios from 'axios';
import Links from "../../../src/Data/Links.js";
import moment from 'moment';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { MONTHS, YEARS, WEEKS } from "../../../src/constants.js"
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Cookies from 'js-cookie';
import "./Sop.css";
const styles = {
    inputField: {
        width: 120
    }
}

const QUESTION_KEYS = [
    "exterior-sidewalk",
    "exterior-windows",
    "exterior-vehicles",
    "exterior-plate-brackets",
    "exterior-stickers",
    "exterior-promotional",
    "exterior-flags",
    "interior-welcome",
    "interior-no-clutter",
    "interior-music",
    "interior-floors",
    "showroom-appearance",
    "showroom-campaign",
    "showroom-brochures",
    "showroom-desks",
    "customer-coffee-water",
    "customer-seating",
    "customer-magazines",
    "customer-charging",
    "customer-tv",
    "customer-bathroom",
    "staff-lunch-room",
    "staff-core-values",
    "staff-ohc-minutes",
    "parts-appearance",
    "parts-campaign",
    "parts-drive-through",
    "parts-shop",
    "parts-counter",
    "parts-tire-display",
    "parts-merchandise"
];

const NOTE_KEYS = [
    "exterior-notes",
    "interior-notes",
    "showroom-notes",
    "customer-notes",
    "staff-notes",
    "parts-notes"
];

const PARTS_QUESTION_KEYS = QUESTION_KEYS.filter((key) => key.startsWith("parts-"));
const BASE_QUESTION_KEYS = QUESTION_KEYS.filter((key) => !key.startsWith("parts-"));
const BASE_NOTE_KEYS = NOTE_KEYS.filter((key) => key !== "parts-notes");

const getStoreOptionLabel = (store) => {
    const division = String(store?.division || "").trim();
    const name = String(store?.name || "").trim();

    if (division === "DriveNation") {
        return `Drive Nation ${name}`.trim();
    }

    if (division === "FFUN Cars") {
        return `FFUN Cars ${name}`.trim();
    }

    return name;
};

const getStoreGroupKey = (store) => {
    const division = String(store?.division || "").trim().toLowerCase();

    if (division === "rec") {
        return "rec";
    }

    if (division === "used" || division === "drivenation" || division === "ffun cars") {
        return "used";
    }

    return "auto";
};

const STORE_GROUPS = [
    { key: "auto", label: "Auto", color: "#0d6efd", backgroundColor: "#e7f1ff" },
    { key: "rec", label: "Rec", color: "#198754", backgroundColor: "#eaf7ee" },
    { key: "used", label: "Used", color: "#b54708", backgroundColor: "#fff1e6" }
];

const YesNoItem = ({ label, name, showNa = false }) => (
    <div className="sop-question-row">
        <span className="sop-question-label">{label}</span>
        <div className="sop-question-controls">
            <RadioGroup row name={name} defaultValue="" className="sop-radio-group">
                <FormControlLabel value="yes" control={<Radio color="success" />} label="Yes" />
                <FormControlLabel value="no" control={<Radio color="error" />} label="No" />
                {showNa && <FormControlLabel value="na" control={<Radio />} label="N/A" />}
            </RadioGroup>
        </div>
    </div>
);

const SectionNote = ({ name }) => (
    <div style={{ marginTop: "12px" }}>
        <label htmlFor={name} style={{ display: "block", fontWeight: 600, marginBottom: "6px" }}>
            Notes
        </label>
        <textarea
            id={name}
            name={name}
            rows={2}
            style={{ width: "100%", borderRadius: "8px", border: "1px solid #d9d9d9", padding: "8px 10px" }}
        />
    </div>
);








const Sop = () => {
    const userName = JSON.parse(Cookies.get('user_data')).userName;
    const [stores, setStores] = useState(localStorage.getItem('stores') ? JSON.parse(localStorage.getItem('stores')) : "");
    const currentYear = moment().format('YYYY');
    const currentMonth = moment().format('MMM');
    const currentDate = moment().format('DD');
    const currentWeek = Math.ceil(currentDate / 7) - 1 > 1 ? Math.ceil(currentDate / 7) - 1 : 1;
    const [month, setMonth] = useState(currentMonth);
    const [years, setYears] = useState([]);
    const [year, setYear] = useState(currentYear);
    const [week, setWeek] = useState(currentWeek);
    let [buttonFlash, setButtonFlash] = useState(false);
    let [currentStore, setCurrentStore] = useState("")

    const allowedDivisionKeys = new Set(["auto", "used", "rec", "drivenation", "ffun cars"]);
    const filteredStores = Array.isArray(stores)
        ? stores.filter((store) => allowedDivisionKeys.has(String(store?.division || "").toLowerCase()))
        : [];
    const groupedStores = STORE_GROUPS.map((group) => ({
        ...group,
        stores: filteredStores.filter((store) => getStoreGroupKey(store) === group.key)
    })).filter((group) => group.stores.length > 0);


    const handleYearChange = (event) => {
        setYear(event.target.value);
        // setButtonFlash(true);
    };
    const handleMonthChange = (event) => {
        setMonth(event.target.value);
        // setButtonFlash(true);
    };

    const handleWeekChange = (event) => {
        setCurrentStore(event.target.value);
        // setButtonFlash(true);
    };

    const handleStoreChange = (event) => {
        setCurrentStore(event.target.value);
        // setButtonFlash(true);
    };



    useEffect(() => {
        setYears(YEARS);
    }, []);

    useEffect(() => {
        if (!filteredStores.length) return;
        const hasSelected = filteredStores.some((store) => String(store.id) === String(currentStore));
        if (!hasSelected) {
            setCurrentStore(filteredStores[0].id);
        }
    }, [filteredStores, currentStore]);

    const selectedStore = filteredStores.find((store) => String(store.id) === String(currentStore));
    const showPartsAndService = selectedStore?.division !== "DriveNation";

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedStore?.name) {
            alert("Please select a store before submitting.");
            return;
        }

        const formData = new FormData(event.currentTarget);
        const answers = {};
        const missing = [];
        const requiredQuestionKeys = showPartsAndService
            ? QUESTION_KEYS
            : BASE_QUESTION_KEYS;

        requiredQuestionKeys.forEach((key) => {
            const value = String(formData.get(key) || "").trim().toLowerCase();
            if (value === "yes" || value === "no" || value === "na") {
                answers[key] = value;
            } else {
                missing.push(key);
            }
        });

        if (showPartsAndService) {
            PARTS_QUESTION_KEYS.forEach((key) => {
                const value = String(formData.get(key) || "").trim().toLowerCase();
                if (value === "yes" || value === "no" || value === "na") {
                    answers[key] = value;
                }
            });
        }

        if (missing.length) {
            alert("Please answer all questions before submitting.");
            return;
        }

        const notes = {};
        const noteKeys = showPartsAndService ? NOTE_KEYS : BASE_NOTE_KEYS;
        noteKeys.forEach((key) => {
            notes[key] = String(formData.get(key) || "").trim();
        });

        const payload = {
            storeId: selectedStore.id,
            storeName: selectedStore.name,
            company: "FFUN",
            submittedBy: userName,
            submittedAt: new Date().toISOString(),
            answers,
            notes
        };

        try {
            await axios.post(Links.createSiteVisitChecklist, payload);
            alert("Your review is submitted successfully!");
            window.location.reload();
        } catch (error) {
            console.error("Site visit checklist submit error:", error);
            alert("Submission failed. Please try again.");
        }
    };


    return (
        <div className="sop-page">

            <Grid item xs={12} container spacing={1}>

                <Grid item xs={12} sm={6} md={3}>
                    <FormControl className="sop-store-selector" variant="standard" sx={{ m: 1, width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">Select a store</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={currentStore}
                            label="Select a store"
                            onChange={handleStoreChange}
                        >
                            {groupedStores.flatMap((group) => ([
                                <ListSubheader
                                    key={`group-${group.key}`}
                                    disableSticky
                                    sx={{
                                        fontWeight: 700,
                                        lineHeight: 1.8,
                                        color: group.color,
                                        backgroundColor: group.backgroundColor
                                    }}
                                >
                                    {group.label}
                                </ListSubheader>,
                                ...group.stores.map((store) => (
                                    <MenuItem key={store.id} value={store.id} sx={{ pl: 3 }}>
                                        {getStoreOptionLabel(store)}
                                    </MenuItem>
                                ))
                            ]))}
                        </Select>
                    </FormControl>
                </Grid>

                

                {/* <Grid item xs={2}>
                    <FormControl variant="standard" sx={{ m: 1, width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">Week</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={week}
                            label="Age"
                            onChange={handleWeekChange}
                        >
                            {Object.values(WEEKS).map((week, index) => (
                                <MenuItem key={index} value={week}>Week {week}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid> */}
                {/* <Grid item xs={3} className="mt-3">
                    <button className={`p-2 mt-1 btn btn-secondary mx-3 ${buttonFlash === true && "button-glow"}`} type="submit"
                        onClick={() => {
                            setButtonFlash(false);
                            showResults()
                        }}
                    >Show Details</button>
                </Grid> */}


            </Grid>

            <form className="mt-4" onSubmit={handleSubmit}>

                <div className="sop-section" style={{ backgroundColor: "#f7f7f7", border: "1px solid #e2e2e2", borderRadius: "12px", padding: "16px 20px", marginBottom: "20px" }}>
                    <h3 style={{ color: "#198754", marginBottom: "12px" }}><DirectionsCarIcon fontSize="large" />{" "}Exterior</h3>
                    <YesNoItem label="Winter - Sidewalk cleared and salted" name="exterior-sidewalk" showNa />
                    <YesNoItem label="Windows clean" name="exterior-windows" />
                    <YesNoItem label="Vehicles aligned, evenly spaced and clean" name="exterior-vehicles" />
                    <YesNoItem label="FFUN plate brackets on all units" name="exterior-plate-brackets" />
                    <YesNoItem label="FFUN stickers on all units" name="exterior-stickers" />
                    <YesNoItem label="Promotional material visible and current" name="exterior-promotional" />
                    <YesNoItem label="FFUN flags up and in good shape" name="exterior-flags" />
                    <SectionNote name="exterior-notes" />
                </div>


                <div className="sop-section" style={{ backgroundColor: "#f7f7f7", border: "1px solid #e2e2e2", borderRadius: "12px", padding: "16px 20px", marginBottom: "20px" }}>
                    <h3 style={{ color: "#198754", marginBottom: "12px" }}><BusinessIcon fontSize="large" />{" "}Interior - First Impression</h3>
                    <YesNoItem label="Warm welcome upon entering" name="interior-welcome" />
                    <YesNoItem label="No clutter in entrance" name="interior-no-clutter" />
                    <YesNoItem label="Music on and appropriate volume" name="interior-music" />
                    <YesNoItem label="Floors clean" name="interior-floors" />
                    <SectionNote name="interior-notes" />
                </div>


                <div className="sop-section" style={{ backgroundColor: "#f7f7f7", border: "1px solid #e2e2e2", borderRadius: "12px", padding: "16px 20px", marginBottom: "20px" }}>
                    <h3 style={{ color: "#198754", marginBottom: "12px" }}><WarehouseIcon fontSize="large" />{" "}Showroom</h3>
                    <YesNoItem label="Appropriate clothing and appearance" name="showroom-appearance" />
                    <YesNoItem label="Sales campaigns/units visible and current" name="showroom-campaign" />
                    <YesNoItem label="Brochures stocked" name="showroom-brochures" />
                    <YesNoItem label="Desks clean" name="showroom-desks" />
                    <SectionNote name="showroom-notes" />
                </div>


                <div className="sop-section" style={{ backgroundColor: "#f7f7f7", border: "1px solid #e2e2e2", borderRadius: "12px", padding: "16px 20px", marginBottom: "20px" }}>
                    <h3 style={{ color: "#198754", marginBottom: "12px" }}><HealthAndSafetyIcon fontSize="large" />{" "}Customer Areas</h3>
                    <YesNoItem label="Coffee/water stocked" name="customer-coffee-water" />
                    <YesNoItem label="Seating clean and arranged" name="customer-seating" />
                    <YesNoItem label="Magazines current" name="customer-magazines" />
                    <YesNoItem label="Charging stations functional" name="customer-charging" />
                    <YesNoItem label="TV content brand-aligned" name="customer-tv" />
                    <YesNoItem label="Bathroom clean and well supplied" name="customer-bathroom" />
                    <SectionNote name="customer-notes" />
                </div>


                <div className="sop-section" style={{ backgroundColor: "#f7f7f7", border: "1px solid #e2e2e2", borderRadius: "12px", padding: "16px 20px", marginBottom: "20px" }}>
                    <h3 style={{ color: "#198754", marginBottom: "12px" }}><BuildIcon fontSize="large" />{" "}Staff Areas</h3>
                    <YesNoItem label="Lunch room clean and user friendly" name="staff-lunch-room" />
                    <YesNoItem label="Core values signage visible" name="staff-core-values" />
                    <YesNoItem label="OHC minutes posted and within last three months" name="staff-ohc-minutes" />
                    <SectionNote name="staff-notes" />
                </div>


                {showPartsAndService && <div className="sop-section" style={{ backgroundColor: "#f7f7f7", border: "1px solid #e2e2e2", borderRadius: "12px", padding: "16px 20px", marginBottom: "20px" }}>
                    <h3 style={{ color: "#198754", marginBottom: "12px" }}><BuildIcon fontSize="large" />{" "}Parts and Service</h3>
                    <YesNoItem label="Appropriate clothing and appearance" name="parts-appearance" />
                    <YesNoItem label="Service campaign visible and current" name="parts-campaign" />
                    <YesNoItem label="Drive through clean and organized" name="parts-drive-through" />
                    <YesNoItem label="Shop clean and organized" name="parts-shop" />
                    <YesNoItem label="Parts counter clean and organized" name="parts-counter" />
                    <YesNoItem label="Tire display visible and current" name="parts-tire-display" />
                    <YesNoItem label="Merchandise faced and dust free" name="parts-merchandise" />
                    <SectionNote name="parts-notes" />
                </div>}

                <button className={`p-2 mb-5 mt-1 btn btn-success mx-3`} type="submit">
                    Submit Review
                </button>

            </form>


            {/*
            <table className="table table-bordered border-black table-fit table-striped mb-5" style={{ marginTop: 20 }}>
                <thead>
                    <tr className="text-center">
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Rank</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Store</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Overall Rank Score</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Entrance</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Sales Lot</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Show Room</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Parts & Service</th>
                        <th colSpan="1" className="dn-header" style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>Safety</th>

                    </tr>
                </thead>
                <tbody>
                    <tr >
                        <td style={{ backgroundColor: 'white', textAlign: 'center' }}>
                            1
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            Acura
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            18
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            1
                        </td>
                    </tr>

                    <tr >
                        <td style={{ backgroundColor: 'white', textAlign: 'center' }}>
                            2
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            VW
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            17
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            1
                        </td>
                    </tr>

                    <tr >
                        <td style={{ backgroundColor: 'white', textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            Hyundai South
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            16
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            1
                        </td>
                    </tr>
                    <tr >
                        <td style={{ backgroundColor: 'white', textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            FFUN Cars
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            15
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            2
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            1
                        </td>
                    </tr>

                    <tr >
                        <td style={{ backgroundColor: 'white', textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            Hyundai North
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            15
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            3
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            2
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            1
                        </td>
                    </tr>

                    <tr >
                        <td style={{ backgroundColor: 'white', textAlign: 'center' }}>
                            6
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            KIA
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            14
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            4
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            2
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            2
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            5
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            1
                        </td>
                    </tr>

                </tbody>
            </table>
            */}

            <div className="py-5"></div>

        </div>)
};

export default Sop;
